import { MIN_OUTPUT_SIZE } from './constants';

export function resizeToSquare(sourceCanvas: HTMLCanvasElement): Promise<string> {
  return new Promise((resolve) => {
    const outputCanvas = document.createElement('canvas');
    outputCanvas.width = MIN_OUTPUT_SIZE;
    outputCanvas.height = MIN_OUTPUT_SIZE;

    const ctx = outputCanvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(sourceCanvas, 0, 0, MIN_OUTPUT_SIZE, MIN_OUTPUT_SIZE);
    }

    resolve(outputCanvas.toDataURL('image/png'));
  });
}
